export default {

  apiKey: "AIzaSyC5hyFGU9fm4B_LYqhydmrUusC4JjKaMgw",
  authDomain: "this-pj.firebaseapp.com",
  databaseURL: "https://this-pj.firebaseio.com",
  projectId: "this-pj",
  storageBucket: "this-pj.appspot.com",
  messagingSenderId: "907702997963",
  appId: "1:907702997963:web:81c97d10130b2122805c4e"

}



// WEBPACK FOOTER //
// ./src/components/fbConfig.js